
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CTeamAktAssignmentUnavailable"
})
export default class CTeamAktAssignmentEmptyResult extends Vue {}
